import { CLAIM_STATUS, RETURN_STAGE } from "../constants";
import type { Claim, ClaimTranslator, NextSteps } from "../types";
import { isAwaitingCustomerReply, isAwaitingReview } from "./claimState";
import { getReturnStage, isReturnRequest } from "./returnState";

const getReturnNextSteps = (
  claim: Claim,
  t: ClaimTranslator,
): NextSteps | null => {
  const stage = getReturnStage(claim);
  if (stage === RETURN_STAGE.RESOLVED) {
    return null;
  }

  const isLabelReady = stage === RETURN_STAGE.LABEL_READY;
  const prefix = `status.returns.${claim.request_type}.${stage}`;
  return {
    title: t("status.nextSteps.reviewTitle"),
    body: t(`${prefix}.nextStepsBody`),
    timeframe: null,
    actionRequired: isLabelReady,
    showNoActionBadge: !isLabelReady,
  };
};

export const getCustomerNextSteps = (
  claim: Claim,
  t: ClaimTranslator,
): NextSteps | null => {
  if (isAwaitingCustomerReply(claim)) {
    return {
      title: t("status.nextSteps.reviewTitle"),
      body: t("status.nextSteps.replyBody"),
      timeframe: null,
      actionRequired: true,
      showNoActionBadge: false,
    };
  }

  if (isReturnRequest(claim) && claim.claim_status !== CLAIM_STATUS.DENIED) {
    return getReturnNextSteps(claim, t);
  }

  if (isAwaitingReview(claim)) {
    return {
      title: t("status.nextSteps.reviewTitle"),
      body: t("status.nextSteps.reviewBody"),
      timeframe: t("status.nextSteps.timeframe"),
      actionRequired: false,
      showNoActionBadge: true,
    };
  }

  if (claim.claim_status === CLAIM_STATUS.DENIED) {
    return {
      title: t("status.nextSteps.deniedTitle"),
      body: t("status.nextSteps.deniedBody"),
      timeframe: null,
      actionRequired: false,
      showNoActionBadge: false,
    };
  }

  return null;
};
